// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-01fb907e] .el-pagination {\n  margin-top: 20px;\n}\n[data-v-01fb907e] .el-pagination .el-pagination__editor {\n  display: inline-block !important;\n}\n.dialog-footer[data-v-01fb907e] {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n}\n", ""]);
// Exports
module.exports = exports;
